





































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PublicQuestionSearch extends Vue {
  @Prop()
  openFilter!: () => void;

  @Prop()
  isLoadingQuestions!: boolean;

  @Prop()
  isLoadingAddQuestions!: boolean;

  @Prop()
  updateKeyword!: (param: string) => void;

  @Prop({ default: '' })
  keyword!: string;

  keywordInput = '';

  created() {
    this.keywordInput = this.keyword;
  }

  filterClicked() {
    this.openFilter();
  }

  keywordSubmitted() {
    if (this.isLoadingQuestions || this.isLoadingAddQuestions) return;

    this.updateKeyword(this.keywordInput);
  }
}
